import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TableTr, TableTd } from 'design/table';
import { PartnerClientsTableItem } from 'types/partnerClientsTable';
import { TextComponent } from 'design/text/textComponents';
import { ClockIcon } from 'svg/24x24/clock';
import { CheckmarkCircleIcon } from 'svg/24x24/checkmark-circle';
import { HoverableTooltipComponent } from 'design/hoverableTooltip/hoverableTooltipComponents';
import { UnderlinedTextComponent } from 'design/underlinedText/underlinedTextComponents';

type Props = {
  monthDateISO: string;
  item: PartnerClientsTableItem;
  active: boolean;
  onClick(item: PartnerClientsTableItem): void;
};

export const PartnerPaidClientsTableRow = (props: Props) => {
  const { monthDateISO, item, active, onClick } = props;

  const { partnerClientsTable: ownDictionary } = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(item);
  }, [onClick, item]);

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={item.organization} />
      <TableTd text={ownDictionary.contactFullNameText(item)} />
      <TableTd text={item.position} />
      <TableTd text={item.phone} />
      <TableTd
        text={item.orgSize ? ownDictionary.orgSizeValue(item.orgSize) : '-'}
      />
      <TableTd text={item.licensesCount} />
      <TableTd
        disableNoBreakHack
        text={
          <HoverableTooltipComponent
            text={ownDictionary.incomeTooltipText(item)}
          >
            <TextComponent
              color={
                item.debitStatus === 'EXPIRED'
                  ? 'accent'
                  : item.debitStatus === 'PAID'
                  ? 'successful'
                  : 'primary'
              }
              size="s"
            >
              <UnderlinedTextComponent>
                {ownDictionary.incomeValue(item.income?.amount || 0)}
              </UnderlinedTextComponent>
            </TextComponent>
          </HoverableTooltipComponent>
        }
      />
      <TableTd
        disableNoBreakHack
        text={
          item.debitStatus === null ? (
            <TextComponent color="primary" size="s">
              {ownDictionary.firstPaybackDateText(monthDateISO)}
            </TextComponent>
          ) : item.debitStatus === 'EXPIRED' ? (
            <HoverableTooltipComponent
              text={ownDictionary.expiredPaybackTooltipText}
            >
              <TextComponent color="accent">
                <ClockIcon style={{ verticalAlign: 'middle' }} />
              </TextComponent>
            </HoverableTooltipComponent>
          ) : (
            item.debitStatus === 'PAID' && (
              <HoverableTooltipComponent
                text={ownDictionary.paidPaybackTooltipText}
              >
                <TextComponent color="successful">
                  <CheckmarkCircleIcon style={{ verticalAlign: 'middle' }} />
                </TextComponent>
              </HoverableTooltipComponent>
            )
          )
        }
      />
      <TableTd
        text={
          <TextComponent
            color={
              item.subscription.status === 'CANCELLED'
                ? 'critical'
                : 'successful'
            }
            size="s"
          >
            {ownDictionary.subscribtionStatusValue(item)}
          </TextComponent>
        }
      />
    </TableTr>
  );
};
